import React, { useState } from 'react'
import axios from 'axios'

export default () => {
    const [passwordInput, setPasswordInput] = useState('')
    const [passwordHash, setPasswordHash] = useState(null)


    const createPassword = () => {
        axios.get(`${window.MYQLOCX_API}/subject/admin/bi/settings/password`, { params: { password: passwordInput } }).then((t) => {
            setPasswordHash(t.data.passwordHash)
        }).catch((e) => {
            setPasswordHash('Fel!')
        })
    }

    return (
        <div>
            <input onChange={e => setPasswordInput(e.target.value)} type="text" placeholder="superhemligt" />
            <button onClick={createPassword}>Skapa lösenord</button>
            {passwordHash && <p>{passwordHash}</p>}
            <hr />
        </div>
    )
}

